// extracted by mini-css-extract-plugin
export default {"language_div":"LanguageSelector_language_div__xVDf3"};